import * as yup from "yup";

export const linkSchema = yup
  .object({
    name: yup.string().trim().required("Name is required").default(""),
    redirect: yup.string().trim().required("Redirect is required").default(""),
    medium: yup.string().trim().required("Medium is required").default(""),
    source: yup.string().trim().required("Source is required").default(""),
    // Share-card overrides. Optional on purpose: blank means "fall back to the
    // linked show, then the site default". Caps mirror the DB columns.
    preview_title: yup
      .string()
      .trim()
      .max(120, "Keep it under 120 characters")
      .default(""),
    preview_description: yup
      .string()
      .trim()
      .max(300, "Keep it under 300 characters")
      .default(""),
  })
  .required();
